import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CartContext } from '@/context/CartContext';
import { WishlistContext } from '@/context/WishlistContext';

const navItems = [
  { to: '/', icon: 'ri-home-line', label: 'Home' },
  { to: '/shop', icon: 'ri-store-line', label: 'Shop' },
  { to: '/about', icon: 'ri-information-line', label: 'About' },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const { itemCount } = useContext(CartContext);
  const { wishlist: wishlistItems } = useContext(WishlistContext);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50 border-t border-background-200/70 safe-bottom">
      <div className="flex items-center justify-around h-14">
        {navItems.map((item) => {
          const active = isActive(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 min-w-0 px-2 py-1 rounded-lg transition-colors duration-200 cursor-pointer ${
                active
                  ? 'text-primary-500'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-[10px] font-label font-medium leading-none whitespace-nowrap">
                {item.label}
              </span>
            </Link>
          );
        })}

        {/* Wishlist */}
        <Link
          to="/shop?filter=wishlist"
          className={`flex flex-col items-center justify-center gap-0.5 min-w-0 px-2 py-1 rounded-lg transition-colors duration-200 cursor-pointer relative ${
            location.search.includes('wishlist')
              ? 'text-primary-500'
              : 'text-foreground-500 hover:text-foreground-700'
          }`}
        >
          <div className="w-5 h-5 flex items-center justify-center relative">
            <i className="ri-heart-line text-lg"></i>
            {wishlistItems.length > 0 && (
              <span className="absolute -top-1.5 -right-2 bg-accent-500 text-primary-800 text-[9px] font-bold min-w-[14px] h-[14px] rounded-full flex items-center justify-center leading-none px-[2px]">
                {wishlistItems.length}
              </span>
            )}
          </div>
          <span className="text-[10px] font-label font-medium leading-none whitespace-nowrap">
            Wishlist
          </span>
        </Link>

        {/* Cart */}
        <Link
          to="/cart"
          className={`flex flex-col items-center justify-center gap-0.5 min-w-0 px-2 py-1 rounded-lg transition-colors duration-200 cursor-pointer relative ${
            isActive('/cart')
              ? 'text-primary-500'
              : 'text-foreground-500 hover:text-foreground-700'
          }`}
        >
          <div className="w-5 h-5 flex items-center justify-center relative">
            <i className="ri-shopping-bag-line text-lg"></i>
            {itemCount > 0 && (
              <span className="absolute -top-1.5 -right-2 bg-accent-500 text-primary-800 text-[9px] font-bold min-w-[14px] h-[14px] rounded-full flex items-center justify-center leading-none px-[2px]">
                {itemCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-label font-medium leading-none whitespace-nowrap">
            Cart
          </span>
        </Link>
      </div>
    </nav>
  );
}